import { Spreadsheet, getRangeAddress } from '@syncfusion/ej2-spreadsheet';
import { Uploader } from '@syncfusion/ej2-inputs';
import { ExcelWorksheetCellModel, ExcelWorksheetModel, SetWorkbookDataModel } from '../../Models/Excel/SetWorkbookDataModel';
import { ExcelDataService } from '../../DataService/ExcelDataService';

import { Grid, Filter, Page, Sort, RecordClickEventArgs, Edit, Toolbar, NewRowPosition } from '@syncfusion/ej2-grids';
import { Query, DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { closest, L10n } from '@syncfusion/ej2-base';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { Toastr } from '../../Helpers/Toastr';
import { DropDownList, ChangeEventArgs } from '@syncfusion/ej2-dropdowns';
import { ConfirmModal } from '../../Helpers/ConfirmModal';
import { LookupDataService } from '../../DataService/LookupDataService';
import { CommonTablesDataService } from '../../DataService/CommonTablesDataService';
import { CustomerArticleCrossReferencesManager } from './CustomerArticleCrossReferencesManager';
import { SyncfusionGridHelper } from '../../Helpers/SyncfusionGridHelper';

export class CustomerCrossReferencesManager {

    constructor(private containerElement: JQuery) { }

    private erpGrid : Grid;
    private crossReferencesGrid : Grid;

    private customerArticleXrefModalHelper : ModalHelper;    
    private customerArticleXrefManager : CustomerArticleCrossReferencesManager;
    

    public initialize() {
        var self = this;

        Grid.Inject(Edit, Toolbar, Filter, Page, Sort);

        self.initializeUploadAndWorkbooksTable();
    }

    private initializeUploadAndWorkbooksTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var customerCrossReferencesContainer = self.containerElement.find('#customer-cross-references-container');

        var articleMatchingEnabled : boolean = self.containerElement.data('article-matching-enabled');
        this.customerArticleXrefModalHelper = new ModalHelper();
        this.customerArticleXrefModalHelper.createModal("customer-article-xref-popup", true);

        var erpContentWrapper : JQuery<HTMLElement> = self.containerElement.find('#erp-workbook-content-wrapper');
        var erpGridElement : JQuery<HTMLElement> = self.containerElement.find('#erp-customer-grid');
        var erpContentElement : JQuery<HTMLElement> = erpGridElement;

        var uploadObject : Uploader;
        var uploadedDocumentId = '';

 
        var crossReferencesGridElement : JQuery<HTMLElement> = self.containerElement.find('#erp-customer-cross-references-grid');
        var crossReferencesContentElement : JQuery<HTMLElement> = crossReferencesGridElement;

        var updateFromErpButton = self.containerElement.find('#update-from-erp-button');
        updateFromErpButton.off('click').on('click', () => {
            new ConfirmModal().initialize('Update customers from ERP', 'Are you sure you want to update the customers from the ERP?</br>This action cannot be reverted.', () => {
                CommonTablesDataService.updateCustomersFromErp((success) => {
                    location.reload();
                })
            }, () => {
            }, 'Confirm', 'Cancel')
        })

        var fileUploadInput = self.containerElement.find('#erp-customer-file-upload-input');
    
        L10n.load({
            "customer-en-US": {
                "uploader": { 
                    "dropFilesHint" : "Drop a file with customer(s) here"
                }
            }
        })

        //TODO: Allow upload of erp customer file
        uploadObject = new Uploader({
            maxFileSize: 40000000,
            autoUpload: false,
            asyncSettings: {
                saveUrl: '/api/company/commontables/erp/uploadcustomerxlsx',
                removeUrl: '/api/company/commontables/removefile'
            },
            multiple: false,
            allowedExtensions: '.xlsx',
            locale: 'customer-en-US',
            created: () => {
                loadingContainer.addClass('d-none');
                customerCrossReferencesContainer.removeClass('d-none');
            },
            beforeUpload: () => {
                //spreadsheetElement.addClass('d-none');
                //spreadsheet.destroy();
            },
            selected: () => {
                erpContentWrapper.css('height', 'calc(85dvh - 98px)');
            },
            success: (args: any) => {                    
                if (args.operation == 'upload') {
                    uploadedDocumentId = args.e.target.response;
                    //spreadsheet.open({ file: args.file.rawFile });
                }
            },
        });

        let erpData: DataManager = new DataManager({
            url: '/api/company/lookup/erp/customer',
            adaptor: new WebApiAdaptor
        });

        var columns : any = [
            { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},    
            { field: 'CreationDateTimeString', headerText: 'Creation date', autoFit: true, allowEditing: false, allowFiltering: false, width: '150px', validationRules: { required: true }}, 
            { field: 'Key', headerText: 'Key', autoFit: true, validationRules: { required: false }},
            { field: 'Name', headerText: 'Name', autoFit: true, validationRules: { required: false }},
        ];

        if(articleMatchingEnabled) {
            //TODO: Create the extra actions partial geval for cross references.
            columns.push(
                { field: 'ExtraActions', headerText: '', allowFiltering: false, allowEditing: false, autoFit: true, width: '75px', textAlign: 'Right', template: '${getErpCustomersExtraActions(data.Id)}' }
            )
        }


        //Check if ArticleMatching is enabled, if so add extra column thing
        self.erpGrid = new Grid(
        {
            height: '100%',
            dataSource: erpData,
            editSettings: { allowEditing: true, allowAdding: false, allowDeleting: false, mode: 'Normal', newRowPosition: 'Top' },
            columns: columns,
            allowSorting: true,
            allowPaging: true,
            allowFiltering: true,
            allowSelection: false,
            toolbarTemplate: '#erp-customer-toolbar-template',
            enablePersistence: true,
            pageSettings: { pageSize: 100 },
            // toolbar: ['Update', 'Cancel'],
            //actionComplete: actionComplete,
            created: () => {
                erpContentElement = erpContentElement.find('.e-content')

                loadingContainer.addClass('d-none');
                customerCrossReferencesContainer.removeClass('d-none');

            },                  
            actionBegin: (args) => {
                if (!this.erpGrid) {
                    return;
                }

                if (SyncfusionGridHelper.isFilterAction(args)) {
                    this.erpGrid.pageSettings.currentPage = 1;
                }
            },
            recordClick: (args: RecordClickEventArgs) => {
                if (args.target != undefined && args.rowData != undefined) {
                    var parsedTarget = $(args.target); 
                    var erpCustomerId = args.rowData["Id"];

                    if(parsedTarget.data('action') == 'edit-erp-customer-article-cross-references' || parsedTarget.parent().data('action') == 'edit-erp-customer-article-cross-references' && erpCustomerId != undefined) {
                        var targetButton = parsedTarget;
                        if(parsedTarget.is('i')) {
                            targetButton = parsedTarget.parent();
                        }

                        targetButton.prop('disabled', true);
                        
                        self.customerArticleXrefModalHelper.load(`/Company/CommonTables/Customer?erpCustomerId=${erpCustomerId}&handler=ErpCustomerArticleCrossReferences`, undefined, () => {
                            if(self.customerArticleXrefManager == undefined) {
                                self.customerArticleXrefManager = new CustomerArticleCrossReferencesManager(self.customerArticleXrefModalHelper.getModalContainer());
                            }

                            self.customerArticleXrefManager.initialize();
                            targetButton.prop('disabled', false);
                        });                    
                    }
                }
            },
        });

        self.erpGrid.appendTo('#erp-customer-grid');
        var customerToolbar = this.containerElement.find('#erp-customer-toolbar-template');
        if(customerToolbar != undefined && customerToolbar.length > 0) {
            var clearFiltersButton = customerToolbar.find('#erp-customer-clear-filters-button');
            clearFiltersButton.off('click').on('click', () => {
                self.erpGrid.pageSettings.currentPage = 1;
                self.erpGrid.clearFiltering();
                self.erpGrid.refreshHeader();
            })
        }

        
        var fileInput = fileUploadInput.get(0);
        // render initialized Uploader
        uploadObject.appendTo(fileInput);

        fileUploadInput.removeClass('d-none');


        let data: DataManager = new DataManager({
            url: '/api/company/lookup/crossreferences/customer',
            adaptor: new WebApiAdaptor
        });

        self.crossReferencesGrid = new Grid(
            {
                height: '100%',
                dataSource: data,
                editSettings: { allowEditing: true, allowAdding: false, allowDeleting: false, mode: 'Normal', newRowPosition: 'Top' },
                columns: [
                    { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},
                    { field: 'CreationDateTimeString', headerText: 'Creation date', autoFit: true, allowEditing: false, allowFiltering: false, width: '150px', validationRules: { required: true }},
                    { field: 'DataSource', headerText: 'Source', autoFit: true, width: '150px', allowSorting: false, allowEditing: false, allowFiltering: false,  validationRules: { required: false }},
                    { field: 'CustomerName', headerText: 'customer', autoFit: true, validationRules: { required: false }},
                    { field: 'ErpCustomerName', headerText: 'ERP customer', autoFit: true, validationRules: { required: false }},
                    { field: 'ExtraActions', headerText: '', allowFiltering: false, allowEditing: false, autoFit: true, width: '75px', textAlign: 'Right', template: '${getCustomerCrossReferencesExtraActions(data.Id)}' }
                ],
                allowSorting: true,
                allowPaging: true,
                allowFiltering: true,
                allowSelection: false,
                toolbarTemplate: '#erp-customer-cross-references-toolbar-template',
                enablePersistence: true,
                pageSettings: { pageSize: 100 },
                // toolbar: ['Update', 'Cancel'],
                //actionComplete: actionComplete,
                created: () => {
                    crossReferencesContentElement = crossReferencesContentElement.find('.e-content')

                    loadingContainer.addClass('d-none');
                    customerCrossReferencesContainer.removeClass('d-none');

                },
                actionBegin: (args) => {
                    if (!this.crossReferencesGrid) {
                        return;
                    }

                    if (SyncfusionGridHelper.isFilterAction(args)) {
                        this.crossReferencesGrid.pageSettings.currentPage = 1;
                    }
                },
                dataBound: () => {
                    self.containerElement.find('button[data-action="remove-customer-xref"]').each((index, element) => {
                        var deleteButton = $(element);
                        deleteButton.off('click').on('click', () => {
                            var xrefId = deleteButton.data('entity-id');
                            new ConfirmModal().initialize('Remove Customer Cross Reference', 'Are you sure you want to remove this cross reference?</br>This action cannot be reverted.', () => {
                                LookupDataService.removeCustomerCrossReference(xrefId, (result) => {
                                    if(result == true) {
                                        var index = self.crossReferencesGrid.getRowIndexByPrimaryKey(xrefId);
                                        var row = self.crossReferencesGrid.getRowByIndex(index);
                                        $(row).remove();
                                    }
                                })
                            }, () => {
                            }, 'Confirm', 'Cancel')
                            
                        })
                    })
                }
            });

        self.crossReferencesGrid.appendTo('#erp-customer-cross-references-grid');

        var crossReferencesToolbar = this.containerElement.find('#erp-customer-cross-references-toolbar-template');
        if(crossReferencesToolbar != undefined && crossReferencesToolbar.length > 0) {
            var clearFiltersButton = crossReferencesToolbar.find('#erp-customer-cross-references-clear-filters-button');
            clearFiltersButton.off('click').on('click', () => {
                self.crossReferencesGrid.pageSettings.currentPage = 1;
                self.crossReferencesGrid.clearFiltering();
                self.crossReferencesGrid.refreshHeader();
            })
        }
    }
    

}